import _ from 'lodash';

function protetskiPozicije() {
    return {
        restrict: 'E',
        controller: ['DS', '$scope', function(DS, $scope) {
            $scope.protetski_rad_naziv = () =>{
                const protetski_rad = DS.get('ProtetskiRad', $scope.entry.protetski_rad);
                if (_.isObject(protetski_rad)) {
                    return protetski_rad.naziv;
                }
                return protetski_rad;
            };
        }],
        template: `
            <div><strong>{{protetski_rad_naziv()}}</strong></div>
            <small>
                <span ng-repeat="pozicija in entry.pozicije track by $index" ng-show="pozicija">[{{pozicija}}] </span>
            </small>
        `
    };
}

export {protetskiPozicije};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/protetskiPozicije.directive.js